import React, { FC } from 'react';
import './SearchCandidateWork.scss';

const SearchCandidateWork: FC = ({ children }) => {
  return <div className='search-work'>{children}</div>;
};

export default SearchCandidateWork;
